import React from 'react'

import './Footer.scss';

function Footer() {
  return (
    <footer className="footer honey-footer">
      <div className="content has-text-centered">
        <p className="block">HoneyShare © 2024 - 2026</p>
        <p className="block is-size-7"><a className="honey-impressum-link" href="/impressum">Impressum</a></p>
      </div>
    </footer>
  );
}

export default Footer;
